// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3n-B1","row":"ProcedureTreatmentSummary_row__3ZJch"};